import { render, staticRenderFns } from "./MpControlVUE.vue?vue&type=template&id=98699e20&scoped=true&"
import script from "./MpControlVUE.vue?vue&type=script&lang=js&"
export * from "./MpControlVUE.vue?vue&type=script&lang=js&"
import style0 from "./MpControlVUE.vue?vue&type=style&index=0&id=98699e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98699e20",
  null
  
)

export default component.exports